import { render, staticRenderFns } from "./message-card.vue?vue&type=template&id=472a94e6&scoped=true&"
import script from "./message-card.vue?vue&type=script&lang=js&"
export * from "./message-card.vue?vue&type=script&lang=js&"
import style0 from "./message-card.styl?vue&type=style&index=0&id=472a94e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a94e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
